import { render, staticRenderFns } from "./PlatformDeviceIcon.vue?vue&type=template&id=afe1e986"
import script from "./PlatformDeviceIcon.vue?vue&type=script&lang=js"
export * from "./PlatformDeviceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports